import { propsTypes, SpriteTypes, spriteCategory } from '../types/sprite-types'
import { uuid } from '@/libs/src/utils/tools'
const options = {
    visible: true,
    width: 100,
    height: 100,
    lineWidth: 0,
    radio: true,
    imageRatio: true,
    disableAnchor:true,
}

export default [
   /*  {
        id: uuid(),
        name: "仪表图",
        type: SpriteTypes.sprite,
        icon: 'icon-gauge',
        categrory: spriteCategory.charts,
        data: {
            name: 'gauge',
            ...options
        },
    },
    {
        id: uuid(),
        name: "条形图",
        type: SpriteTypes.sprite,
        icon: 'icon-histogram',
        categrory: spriteCategory.charts,
        data: {
            name: 'histogram',
            ...options
        },
    },
    {
        id: uuid(),
        name: "线形图",
        type: SpriteTypes.sprite,
        icon: 'icon-line-chart-line',
        categrory: spriteCategory.charts,
        data: {
            name: 'lineChart',
            ...options
        },
    },
    {
        id: uuid(),
        name: "饼图",
        type: SpriteTypes.sprite,
        icon: 'icon-pie-chart',
        categrory: spriteCategory.charts,
        data: {
            name: 'pieChart',
            ...options
        },
    }, */
    {
        id: uuid(),
        name: "关键帧动画",
        type: SpriteTypes.sprite,
        icon: 'icon-donghua',
        categrory: spriteCategory.charts,
        data: {
            name: 'echarts',
            x: 100,
            y: 100,
            externElement: true,
            disableAnchor: true,
            lineWidth:0,
            ...options,
            width: 400,
            height: 400,
            echarts:{
                option:{
                    graphic: {
                        elements: [
                          {
                            type: 'text',
                            left: 'center',
                            top: 'center',
                            style: {
                              text: '合续环境科技开发',
                              fontSize: 80,
                              fontWeight: 'bold',
                              lineDash: [0, 200],
                              lineDashOffset: 0,
                              fill: 'transparent',
                              stroke: '#000',
                              lineWidth: 1
                            },
                            keyframeAnimation: {
                              duration: 3000,
                              loop: true,
                              keyframes: [
                                {
                                  percent: 0.7,
                                  style: {
                                    fill: 'transparent',
                                    lineDashOffset: 200,
                                    lineDash: [200, 0]
                                  }
                                },
                                {
                                  // Stop for a while.
                                  percent: 0.8,
                                  style: {
                                    fill: 'transparent'
                                  }
                                },
                                {
                                  percent: 1,
                                  style: {
                                    fill: 'black'
                                  }
                                }
                              ]
                            }
                          }
                        ]
                      }
                }
            }
        },
    },
    {
        id: uuid(),
        name: "仪表图",
        type: SpriteTypes.sprite,
        icon: 'icon-gauge',
        categrory: spriteCategory.charts,
        data: {
            name: 'echarts',
            x: 100,
            y: 100,
            externElement: true,
            disableAnchor: true,
            lineWidth:0,
            ...options,
            width: 400,
            height: 400,
            echarts:{
                option:{
                    tooltip: {
                      formatter: '{a} <br/>{b} : {c}%'
                    },
                    series: [
                      {
                        name: 'Pressure',
                        type: 'gauge',
                        progress: {
                          show: true
                        },
                        detail: {
                          valueAnimation: true,
                          formatter: '{value}'
                        },
                        data: [
                          {
                            value: 50,
                            name: 'SCORE'
                          }
                        ]
                      }
                    ]
                  }
            }
        },
    },
    {
        id: uuid(),
        name: "饼图",
        type: SpriteTypes.sprite,
        icon: 'icon-pie-chart',
        categrory: spriteCategory.charts,
        data: {
            name: 'echarts',
            x: 100,
            y: 100,
            externElement: true,
            disableAnchor: true,
            lineWidth:0,
            ...options,
            width: 400,
            height: 400,
            echarts:{
                option:{
                    title: {
                      text: 'Referer of a Website',
                      subtext: 'Fake Data',
                      left: 'center'
                    },
                    tooltip: {
                      trigger: 'item'
                    },
                    legend: {
                      orient: 'vertical',
                      left: 'left'
                    },
                    series: [
                      {
                        name: 'Access From',
                        type: 'pie',
                        radius: '50%',
                        data: [
                          { value: 1048, name: 'Search Engine' },
                          { value: 735, name: 'Direct' },
                          { value: 580, name: 'Email' },
                          { value: 484, name: 'Union Ads' },
                          { value: 300, name: 'Video Ads' }
                        ],
                        emphasis: {
                          itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                          }
                        }
                      }
                    ]
                  }
            }
        },
    },
    {
        id: uuid(),
        name: "条形图",
        type: SpriteTypes.sprite,
        icon: 'icon-histogram',
        categrory: spriteCategory.charts,
        data: {
            name: "echarts",
            x: 100,
            y: 100,
            externElement: true,
            disableAnchor: true,
            lineWidth:0,
            ...options,
            width: 400,
            height: 300,
            echarts:{
                option:{
                    tooltip: {
                      trigger: 'axis',
                      axisPointer: {
                        type: 'shadow'
                      }
                    },
                    grid: {
                      left: '3%',
                      right: '4%',
                      bottom: '3%',
                      containLabel: true
                    },
                    xAxis: [
                      {
                        type: 'category',
                        data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                        axisTick: {
                          alignWithLabel: true
                        }
                      }
                    ],
                    yAxis: [
                      {
                        type: 'value'
                      }
                    ],
                    series: [
                      {
                        name: 'Direct',
                        type: 'bar',
                        barWidth: '60%',
                        data: [10, 52, 200, 334, 390, 330, 220]
                      }
                    ]
                  }
            }
        },
    },
    {
        id: uuid(),
        name: "折线统计图",
        type: SpriteTypes.sprite,
        icon: 'icon-line-chart-line',
        categrory: spriteCategory.charts,
        data: {
            name: "echarts",
            x: 100,
            y: 100,
            width: 400,
            height: 300,
            externElement: true,
            disableAnchor: true,
            lineWidth:0,
            echarts: {
                option: {
                    xAxis: {
                        type: "category",
                        data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
                    },
                    yAxis: {
                        type: "value",
                    },
                    series: [
                        {
                            data: [820, 932, 901, 934, 1290, 1330, 1320],
                            type: "line",
                        },
                    ],
                },
            },
        }
    }
]
